import React, { useEffect, useState } from 'react';
import '../styles/Homepage.css';
import { AnimatePresence, motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import ScrollAnimation from '../components/ScrollAnimation';
import StaggeredAnimation from '../components/StaggeredAnimation';
import QuotesIcon from '../website_images/Icons/quotesIcon.png';
import NavigationButton from '../website_images/Icons/arrow.png'
import ReferencePhoto from '../website_images/Fotos/reference-header.png'
import PersonalPhoto from '../website_images/Fotos/personal_photo.png'
import ImageSliderPic from '../website_images/Fotos/image_slider.png'
import ProjectKOPhoto from '../website_images/Fotos/projectKO.png'
import ProjectJEPhoto from '../website_images/Fotos/projectJE.png'
import ProjectMB91Photo from '../website_images/Fotos/projectMB91.png'

import { Link } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { HashLink } from 'react-router-hash-link';

const Homepage: React.FC = () => {
    const { t } = useTranslation();
    const [currentSlide, setCurrentSlide] = useState(0);
    const [investmentImageCurrentSlide, setCurrentInvestmentImageSlide] = useState(0);
    const [currentThemesCurrentSlide, setCurrentThemesSlide] = useState(0);

    const investmentImageSlides = [
        {
            id: 1,
            title: t('homepageProjectSM5'),
            address: t('homepageProjectSM5Address'),
            units: t('homepageProjectSM5Units'),
            imageURL: ReferencePhoto,
            navigation: "/project-sm"
        },
        {
            id: 2,
            title: t('homepageProjectTU33'),
            address: t('homepageProjectTU33Address'),
            units: t('homepageProjectTU33Units'),
            imageURL: ImageSliderPic,
            navigation: "/project-tu"
        },
        {
            id: 3,
            title: t('homepageProjectKO'),
            address: t('homepageProjectKOAddress'),
            units: t('homepageProjectKOUnits'),
            imageURL: ProjectKOPhoto,
            navigation: "/project-ko"
        },
        {
            id: 4,
            title: t('homepageProjectJE'),
            address: t('homepageProjectJEAddress'),
            units: t('homepageProjectJEUnits'),
            imageURL: ProjectJEPhoto,
            navigation: "/project-je"
        },
        {
            id: 5,
            title: t('homepageProjectMB91'),
            address: t('homepageProjectMB91Address'),
            units: t('homepageProjectMB91Units'),
            imageURL: ProjectMB91Photo,
            navigation: "/project-mb91"
        }
    ];

    const currentThemesSlides = [
        {
            id: 1,
            title: "TOLLE NEUIGKEITEN",
            description: "Das ist ein Platzhaltertext ohne jegliche Bedeutung. Es würde zu viel Zeit in Anspruch nehmen, sich tatsächlich realistische News auszudenken.."
        },
        {
            id: 2,
            title: "TOLLE NEUIGKEITEN",
            description: "Das ist ein Platzhaltertext ohne jegliche Bedeutung. Es würde zu viel Zeit in Anspruch nehmen, sich tatsächlich realistische News auszudenken.."
        },
        {
            id: 3,
            title: "TOLLE NEUIGKEITEN",
            description: "Das ist ein Platzhaltertext ohne jegliche Bedeutung. Es würde zu viel Zeit in Anspruch nehmen, sich tatsächlich realistische News auszudenken.."
        }
    ];

    const tileSets = [
        [
            {
                id: 1,
                title: t('homepageAcquisition'),
                description: t('homepageAcquisitionDesc'),
                navigation: "/investmentansatz?section=product-overview",
            },
            {
                id: 2,
                title: t('homepageExit'),
                description: t('homepageExitDesc'),
                navigation: "/referenzen#investment-options",
            },
        ]
    ];

    {/**
        {
            id: 3,
            title: t('homepageParticipation'),
            description: t('homepageParticipationDesc'),
            navigation: "/referenzen",
        }
    */}

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % tileSets.length);
        }, 8000);
        return () => clearInterval(timer);
    }, [tileSets.length]);

    {/** Hide auto slide change for now
        useEffect(() => {
            const timer = setInterval(() => {
                setCurrentInvestmentImageSlide((prev) => (prev + 1) % investmentImageSlides.length);
            }, 5000);
        return () => clearInterval(timer);
       }, [investmentImageSlides.length]);
    */}

    const nextSlide = () => {
        setCurrentInvestmentImageSlide((prev) => (prev + 1) % investmentImageSlides.length);
    };

    const prevSlide = () => {
        setCurrentInvestmentImageSlide((prev) => (prev - 1 + investmentImageSlides.length) % investmentImageSlides.length);
    };

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentThemesSlide((prev) => (prev + 1) % currentThemesSlides.length);
        }, 5000);
        return () => clearInterval(timer);
    }, [currentThemesSlides.length]);

    const nextThemeSlide = () => {
        setCurrentThemesSlide((prev) => (prev + 1) % currentThemesSlides.length);
    };

    const prevThemeSlide = () => {
        setCurrentThemesSlide((prev) => (prev - 1 + currentThemesSlides.length) % currentThemesSlides.length);
    };


    const slideVariants = {
        enter: {
            x: 300,
            opacity: 0
        },
        center: {
            zIndex: 1,
            x: 0,
            opacity: 1
        },
        exit: {
            zIndex: 0,
            x: -300,
            opacity: 0
        }
    };

    const slideTransition = {
        x: { type: "spring" as const, stiffness: 300, damping: 30 },
        opacity: { duration: 0.6 }
    };


    return (
        <div className='container'>
            <section className='header-section'> </section>
            <section className='main-section'>
                <ScrollAnimation animation="fadeInUp" delay={0.1}>
                    <h1>{t('homepageHeroH1')}</h1>
                    <h2>{t('homepageHeroH2')}</h2>
                    <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('homepageHeroP')) }}></p>
                </ScrollAnimation>
            </section>
            <section className="hero-section section-investmentProducts">
                <div className='slider-section'>
                    <ScrollAnimation animation="fadeInUp" delay={0.1}>
                        <h1>{t('homepageInvestmentH1')}</h1>
                    </ScrollAnimation>
                    <ScrollAnimation animation="fadeInUp" delay={0.1}>
                        <p className='homepageInvestmentP'>{t('homepageInvestmentH2')}</p>
                    </ScrollAnimation>
                                    <ScrollAnimation animation="fadeInUp" delay={0.1}>
                                        <section className="hero-section">
                                            <div className="slider-container">
                                                <AnimatePresence mode="wait">
                                                    <motion.div
                                                        key={currentSlide}
                                                        className="tiles-slide"
                                                        initial={{ opacity: 0 }}
                                                        animate={{ opacity: 1 }}
                                                        exit={{ opacity: 0 }}
                                                        transition={{ duration: 0.3 }}
                                                        style={{ pointerEvents: 'auto' }}
                                                    >
                                                        <div className="tiles-grid">
                                                            {tileSets[currentSlide].map((tile, index) => (
                                                                <HashLink 
                                                                    key={tile.id}
                                                                    to={tile.navigation}
                                                                    className="tile"
                                                                    style={{ 
                                                                        WebkitTapHighlightColor: 'rgba(143, 121, 174, 0.3)',
                                                                        pointerEvents: 'auto',
                                                                        textDecoration: 'none'
                                                                    }}
                                                                >
                                                                    <div className="homepage-tile-content">
                                                                        <h3 className="tile-title">
                                                                            {tile.title}
                                                                        </h3>
                                                                        <p className={`tile-description-homepage ${index < 2 ? 'apply-margin-top' : ''}`}>
                                                                            {tile.description}
                                                                        </p>
                                                                    </div>
                                                                </HashLink>
                                                            ))}
                                                        </div>
                                                    </motion.div>
                                                </AnimatePresence>
                                            </div>
                                        </section>
                                    </ScrollAnimation>
                </div>
            </section>
            <ScrollAnimation animation="fadeInUp" delay={0.7}>
                <section className='main-section'>
                    <h1>{t('homepageKnowhowH1')}</h1>
                    <h2>{t('homepageKnowhowH2')}</h2>
                    <p>{t('homepageKnowhowP')}</p>
                    <div className="contact-button-section">
                        <Link to='/unternehmen' className="knowhow-button-section">{t('homepageDiscoverCompanies')}</Link>
                    </div>
                </section>
            </ScrollAnimation>
            <ScrollAnimation animation="fadeInUp" delay={0.8}>
                <section className="hero-section section-investmentProducts">
                    <div className="slider-section">
                        <h1 className="projects-header">{t('homepageProjectsH1')}</h1>
                        <section className="hero-section investment-projects">
                            <div className="slider-container-investmentProjects">
                                <div className="carousel-container">
                                    {/* Previous slide preview */}
                                    <div className="slide-preview prev-slide">
                                        <div className="slide-image">
                                            <img src={investmentImageSlides[(investmentImageCurrentSlide - 1 + investmentImageSlides.length) % investmentImageSlides.length].imageURL} alt="Previous" />
                                            <div className="image-overlay"></div>
                                        </div>
                                    </div>

                                    {/* Current slide */}
                                    <Link to={investmentImageSlides[investmentImageCurrentSlide].navigation}>
                                        <div className="slide current-slide">
                                            <div className="slide-image">
                                                <img src={investmentImageSlides[investmentImageCurrentSlide].imageURL} alt={investmentImageSlides[investmentImageCurrentSlide].title} />
                                                <div className="image-overlay"></div>
                                            </div>
                                            <div className="slide-content">
                                                <h1 className="slide-title">
                                                    {investmentImageSlides[investmentImageCurrentSlide].title}
                                                </h1>
                                                <p className="slide-description">
                                                    {investmentImageSlides[investmentImageCurrentSlide].address}
                                                </p>
                                                <p className="slide-units">
                                                    {investmentImageSlides[investmentImageCurrentSlide].units}
                                                </p>
                                            </div>
                                        </div>
                                    </Link>

                                    {/* Next slide preview */}
                                    <div className="slide-preview next-slide">
                                        <div className="slide-image">
                                            <img src={investmentImageSlides[(investmentImageCurrentSlide + 1) % investmentImageSlides.length].imageURL} alt="Next" />
                                            <div className="image-overlay"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button className="slider-nav prev" onClick={prevSlide}>
                                <img src={NavigationButton}></img>
                            </button>
                            <button className="slider-nav next" onClick={nextSlide}>
                                <img src={NavigationButton}></img>
                            </button>
                        </section>
                        <ScrollAnimation animation="fadeInUp" delay={0.1}>
                            <div className="contact-button-section references">
                                <Link to='/referenzen' className="contact-button">{t('homepageToProjectsButton')}</Link>
                            </div>
                        </ScrollAnimation>
                    </div>
                </section>
            </ScrollAnimation>
            <ScrollAnimation animation="fadeInUp" delay={0.6}>
                <section className='main-section'>
                    <h1>{t('homepageFutureH1')}</h1>
                    <h2>{t('homepageFutureH2')}</h2>
                    <p>{t('homepageFutureP')}</p>
                </section>
            </ScrollAnimation>
            <ScrollAnimation animation="fadeInUp" delay={0.7}>
                <section className='main-section'>
                    <h2>{t('homepageESGH2')}</h2>
                    <p>{t('homepageESGP')}</p>
                </section>
            </ScrollAnimation>
            {/** Hide this section for now
            <section className="hero-section section-investmentProducts">
                <div className="slider-section">
                    <h1 className="projects-header">Aktuelle Themen für Immobilien-investoren</h1>
                    <div className="filter-container">
                        <label className="filter-label">Filter</label>
                        <div className="filter-select">
                            <span className="filter-placeholder"></span>
                            <span className="filter-arrow">&#9662;</span>
                        </div>
                    </div>
                    <section className="hero-section investment-projects">
                        <div className="slider-container">
                            <AnimatePresence mode="wait">
                                <motion.div
                                    key={currentThemesCurrentSlide}
                                    className="slide"
                                    variants={slideVariants}
                                    initial="enter"
                                    animate="center"
                                    exit="exit"
                                    transition={slideTransition}
                                >
                                    <div className="slide-image">
                                        <img src={ReferencePhoto} alt={currentThemesSlides[currentThemesCurrentSlide].title} />
                                        <div className="image-overlay"></div>
                                    </div>
                                    <div className="slide-content">
                                        <motion.h1
                                            initial={{ opacity: 0, y: 30 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ delay: 0.2 }}
                                            className="slide-title"
                                        >
                                            {currentThemesSlides[currentThemesCurrentSlide].title}
                                        </motion.h1>
                                        <motion.p
                                            initial={{ opacity: 0, y: 30 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ delay: 0.4 }}
                                            className="slide-description"
                                        >
                                            {currentThemesSlides[currentThemesCurrentSlide].description}
                                        </motion.p>
                                    </div>
                                </motion.div>
                            </AnimatePresence>
                        </div>
                        <button className="slider-nav prev" onClick={prevThemeSlide}>
                            <img src={NavigationButton}></img>
                        </button>
                        <button className="slider-nav next" onClick={nextThemeSlide}>
                            <img src={NavigationButton}></img>
                        </button>
                    </section>
                    <div className="contact-button-section references">
                        <Link to='/kontakt' className="contact-button">Jetzt informieren</Link>
                    </div>
                </div>
            </section>*/}
            <ScrollAnimation animation="fadeInUp" delay={0.8}>
                <section className='main-section'>
                    <h1 className="header-contact">{t('homepageContactH1')}</h1>
                    <h2>{t('homepageContactH2')}</h2>
                    <div className="contact-button-section">
                        <Link to='/kontakt' className="knowhow-button-section">{t('homepageContactButtonFinal')}</Link>
                    </div>
                </section>
            </ScrollAnimation>
        </div>
    );
};

export default Homepage;